import { render, staticRenderFns } from "./StageAsideTile.vue?vue&type=template&id=51bbe38a&scoped=true&lang=pug&"
import script from "./StageAsideTile.vue?vue&type=script&lang=js&"
export * from "./StageAsideTile.vue?vue&type=script&lang=js&"
import style0 from "./StageAsideTile.vue?vue&type=style&index=0&id=51bbe38a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51bbe38a",
  null
  
)

export default component.exports